import { lazy } from "react";

const DevisViewer = lazy(() => import("./DevisViewer"));
const DevisDetails = lazy(() => import("./DevisDetails"));
const DevisContainer=lazy(()=>import ("./DevisContainer"));
const DevisEditor =lazy(()=>import("./devisEditor"));
const devisRoutes = [
  {
    path: "/devis",
    element: <DevisContainer />,
  },
  {
    path: "/devis/new",
    element: <DevisDetails />,
  },
  {
    path: "/devis/:id",
    element: <DevisViewer />,
  },
  {
    path:"/devis/:id/edit",
    element:<DevisEditor isNewDevis={false} />

  } 

];

export default devisRoutes;
